import { UpdateLocationNetworkListModel, CreateLocationNetworkListModel } from "@truckdown/locations";
import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class NetworkListValidator implements IValidator {
    constructor(list: CreateLocationNetworkListModel | UpdateLocationNetworkListModel | undefined) {
        this._list = list;
        this._validators = this.getValidators();
    }

    private _list: CreateLocationNetworkListModel | UpdateLocationNetworkListModel | undefined;
    private _validators: IPropertyValidator[];
    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "networkId",
                message: () => "Network list id is required.",
                validator: () => this.validateString(this._list?.networkId)
            },
           
            {
                key: "code",
                message: () => "Select a network name.",
                validator: () => this.validateString(this._list?.code)
            }
        ];
    }

    private validateString(title: string | undefined): boolean {
        let isValid = false;
        if (title && title.trim().length > 0) {
            isValid = true;
        }

        return isValid;
    }

  
    reset() {
        this.errors = {};
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    errors: { [key: string]: string } = {};
}